import { Avatar, Empty, Flex, Rate } from "antd";
import { useGetMyReviewQuery } from "../../../../app/features/courses/courses.api";
import IMAGES from "../../../../assets/images";
import useError from "../../../../hooks/useError";
import { formatDate } from "../../../../utils/time.utils";
import ReviewListLoading from "./ReviewListLoading";

export default function ReviewList() {
  const { data, isLoading, error } = useGetMyReviewQuery();
  useError(error, "Failed to load reviews");

  const reviewList = data?.items || [];

  if (isLoading) {
    return <ReviewListLoading />;
  }

  return (
    <section className="p-6 rounded-xl border border-theme-slate-200 space-y-4">
      {reviewList?.length > 0 ? (
        reviewList?.map((review) => (
          <div
            key={review.id}
            className="border-b border-theme-zinc-200 pb-3 last:border-b-0 last:pb-0"
          >
            <Flex align="center" justify="space-between" wrap gap={16}>
              <Flex align="center">
                <Flex align="center" wrap gap={12}>
                  <Avatar
                    src={review?.userAvatar || IMAGES.avatar}
                    className="w-14 h-14 rounded-full"
                  />

                  <div>
                    <h6 className="text-theme-slate-700 text-lg font-normal leading-8">
                      {review.userName}
                    </h6>
                    <p className="text-theme-slate-500 text-sm font-normal">
                      {formatDate(review.createdAt)}
                    </p>
                  </div>
                </Flex>
              </Flex>

              <Rate
                value={review.rating}
                count={5}
                disabled
                className="custom-rate"
              />
            </Flex>
            <p className="text-theme-slate-600 text-sm font-normal leading-6 mt-3">
              {review.comment}
            </p>
          </div>
        ))
      ) : (
        <div>
          <Empty />
        </div>
      )}
    </section>
  );
}
